// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"5814ed72","213":"9e7bde2b","475":"e0c70554","580":"2f334996","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};